import '../../../js/vendors/fancybox/jquery.fancybox';

function showAlternativeGrid () {
    $( '[data-fancybox^="fancybox-grid-alternative-"]' ).fancybox( {
        baseClass: "fancybox-grid-alternative",
        hash: false
    } );
}

export default showAlternativeGrid;
